// Modèles LLM sélectionnables : la liste vient du registre backend
// (backend/app/services/model_registry.py) via GET /chat/models.
import { fetchWithAuth } from './fetchWithAuth';
import logger from './logger';

// Routes unifiées : le backend aiguille vers le fournisseur du modèle demandé
export const URL_API_LLM = `${process.env.REACT_APP_API_URL_BOT}/chat/llm`;
export const URL_API_LLM_STREAM = `${process.env.REACT_APP_API_URL_BOT}/chat/llm/stream`;

const URL_API_MODELS = `${process.env.REACT_APP_API_URL_BOT}/chat/models`;

// Repli si le registre est injoignable : le chat ne doit jamais être bloqué
export const FALLBACK_MODELS = [
  { id: 'mistral-medium', label: 'Mistral Medium', provider: 'mistral', hint: 'Équilibré', sovereign: true },
];

let cache = null; // un seul appel par session

export const fetchModels = async () => {
  if (cache) return cache;
  try {
    const res = await fetchWithAuth(URL_API_MODELS);
    if (!res.ok) throw new Error(`Erreur HTTP ${res.status}`);
    const data = await res.json();
    const models = data.models?.length ? data.models : FALLBACK_MODELS;
    cache = { models, default: data.default || models[0].id, ok: true };
    return cache;
  } catch (e) {
    logger.error('Liste des modèles indisponible, repli sur le modèle par défaut:', e);
    // ok:false -> l'appelant peut retenter plus tard (pas de mise en cache de l'échec)
    return { models: FALLBACK_MODELS, default: FALLBACK_MODELS[0].id, ok: false };
  }
};
